export default {
    install(Vue) {
        Vue.filter("truncate", function(text, stop, clamp) {
            stop = stop || 150;
            clamp = clamp || "...";
            let r_text = text.slice(0, stop).trim();
            return r_text + (r_text.length < text.length ? clamp : "");
        });
    }
};
